import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { getImageUrl, getCompressedImageUrl } from "../utils/imageUtils";
import "./Navbar.css";

const Navbar = () => {
  const { user, logout, loading } = useAuth();
  const { cartItems, removeFromCart, getCartTotal } = useCart();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="logo-container">
          <Link to="/">
            <img
              src="/Logo.png"
              alt="Queen Jewelry Logo"
              className="logo-image"
            />
          </Link>
        </div>
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? "open" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-links ${isMobileMenuOpen ? "mobile-open" : ""}`}>
          <li>
            <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/shop" onClick={() => setIsMobileMenuOpen(false)}>
              Shop
            </Link>
          </li>
          <li>
            <Link
              to="/gold-by-weight"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Gold by Weight
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>
              About
            </Link>
          </li>
          <li>
            <Link to="/certificates" onClick={() => setIsMobileMenuOpen(false)}>
              Certificates
            </Link>
          </li>
          <li>
            <Link to="/shipping" onClick={() => setIsMobileMenuOpen(false)}>
              Shipping
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>
        <div className="nav-actions">
          <div className="nav-auth">
            {loading ? (
              <span>Loading...</span>
            ) : user ? (
              <div className="nav-auth-user">
                <span className="user-name">Hello, {user.name}</span>
                <Link to="/orders" className="orders-link">
                  My Orders
                </Link>
                {Boolean(user.isAdmin) && (
                  <Link to="/admin" className="admin-link">
                    Admin Panel
                  </Link>
                )}
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </div>
            ) : (
              <div className="auth-links">
                <Link to="/login" className="auth-link">
                  Login
                </Link>
                <Link to="/register" className="auth-link">
                  Register
                </Link>
              </div>
            )}
          </div>
          <div className="nav-cart" onClick={toggleCart}>
            <span className="cart-icon">🛒</span>
            <span className="cart-count">{cartItems.length}</span>
            <div className={`cart-dropdown ${isCartOpen ? "open" : ""}`}>
              {cartItems.length === 0 ? (
                <p className="empty-cart">Your cart is empty</p>
              ) : (
                <>
                  <div className="cart-items">
                    {cartItems.map((item) => (
                      <div key={item._id} className="cart-item">
                        <img
                          src={getCompressedImageUrl(item.image, "thumbnail")}
                          alt={item.name}
                          className="cart-item-image"
                        />
                        <div className="cart-item-details">
                          <h4>{item.name}</h4>
                          <p>
                            $
                            {(item.finalPrice && !isNaN(Number(item.finalPrice))
                              ? Number(item.finalPrice)
                              : 0
                            ).toFixed(2)}{" "}
                            x {item.quantity}
                          </p>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFromCart(item._id);
                          }}
                          className="remove-item"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="cart-total">
                    <strong>Total: ${getCartTotal().toFixed(2)}</strong>
                  </div>
                  <Link
                    to="/cart"
                    className="view-cart-btn"
                    onClick={toggleCart}
                  >
                    View Cart
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
